import { TermsDto } from './terms.dto';
import { RootState } from '../../store/reducers';

export const selectTermsAndConditions = (state: RootState): TermsDto => {
  return state.terms;
};
